<script setup lang="ts">
import StatsGraph from '../../components/global/StatsGraph.vue';
import {computed, onMounted, ref} from "vue";
import {useTicketStore} from '../../store/tickets';

// Make this global
interface ChartItem {
    date: string;
    primary: number;
    secondary: number;
    tertiary: number;
}

const date = ref(new Date())
const next_date = computed(() => date.value.setMonth(date.value.getMonth() + 1))
const last_date = computed(() => date.value.setMonth(date.value.getMonth() - 1))

const ticketStore = useTicketStore()
const is_loading = ref(false)

const next = async () => {
    date.value = new Date(date.value.setMonth(date.value.getMonth() + 1))
    await getData()
}

const prev = async () => {
    date.value = new Date(date.value.setMonth(date.value.getMonth() - 1))
    await getData()
}

const getData = async () => {
    is_loading.value = true
    await ticketStore.getStats(date.value)
    is_loading.value = false
}

onMounted(async () => {
    await getData()
})
</script>

<template>
    <main>
        <div class="date-select-container">
            <button @click="prev">
                <ah-icon name="arrow-left" />
                {{ new Date(last_date).toLocaleDateString('en-US', { month: "short", year: 'numeric' }) }}
            </button>

            <p>
                {{ new Date(date).toLocaleDateString('en-US', { month: "short", year: 'numeric' }) }}
            </p>

            <button @click="next">
                {{ new Date(next_date).toLocaleDateString('en-US', { month: "short", year: 'numeric' }) }}
                <ah-icon name="arrow-right" />
            </button>
        </div>

        <StatsGraph
            v-if="ticketStore.stats && !is_loading"
            :period="ticketStore?.stats?.period"
            :chart_data="ticketStore?.stats?.chart_data"
            :labels="ticketStore?.stats?.labels"
            :stats="ticketStore?.stats?.stats"
        />
    </main>
</template>

<style lang="scss">
.date-select {
    &-container {
        display: flex;
        align-items: center;
        gap: 4rem;
        justify-content: center;
        margin-bottom: 2rem;
        padding: .8rem 0;

        p {
            @include font(3,3,black);
        }

        button {
            width: 14rem;
            height: 4.4rem;
            border-radius: 2.4rem;
            background: var(--color-white);
            border: none;
            display: flex;
            gap: 1rem;
            justify-content: space-between;
            align-items: center;
            padding: 1rem 1rem 1rem 2rem;
            transition: .3s ease-in-out;
            @include font(1.4,1.4,black);

            .icon {
                transition: .3s ease-in-out;
                fill: var(--color-hazy);
            }

            &:first-child {
                padding: 1rem 2rem 1rem 1rem;
            }

            &:hover {
                background: var(--color-raspberry);
                color: var(--color-white);

                .icon {
                    fill: var(--color-white);
                }
            }
        }

        @include dark() {
            button {
                background: var(--color-darth-maul);
                color: var(--color-mist);

                .icon {
                    fill: var(--color-mist);
                }

                &:hover {
                    background: var(--color-raspberry);
                }
            }

            p {
                color: var(--color-mist);
            }
        }
    }
}
</style>
